// Generated by scripts/icons/build-icon-components.mjs from the matching
// file in ./svg — edit the SVG and re-run the script, not this file.
import SvgIcon, { type SvgIconProps } from '@mui/material/SvgIcon';

const TrainingIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <g fill="currentColor">
      <path d="M9.79 4.45c.96-.35 1.7-.75 2.78-.56.5.09.99.3 1.47.48q1.52.58 3 1.25c1.2.53 2.45.95 3.64 1.5.62.28 1.32.41 1.78.97.12.68-.02.95-.65 1.24-.41.2-.84.33-1.26.5l-3.28 1.35c-1.36.56-3.36 1.58-4.74 1.83-1.75.32-4.46-1.42-6.13-1.96-.84-.27-1.76-.7-2.62-1.05l-.36-.14-.03-.06c-.05-.12-.09-.3-.12-.43.62-.04 1.68-.01 2.33-.01h5.95c.32-.02.83.04 1.08-.22.45-.46.33-1-.06-1.43-.5-.18-3.1-.11-3.76-.11H3.46c-.3 0-.75 0-.96-.2q.46-.14.88-.32c1.07-.49 2.2-.87 3.27-1.33q1.56-.7 3.14-1.3" />
      <path
        d="M3.42 9.86c-.15.02-.12.14-.12.25q-.03 2.8-.01 5.6.01 1.66-.03 3.32c-.02.57-.15.9-.71 1.1-.48.16-.92-.29-1-.7-.07-.32-.04-.9-.04-1.25v-6.87c0-.47-.06-2.97.11-3.23l.01-.02c.18-.27.55-.59.87-.66.21.2.66.2.96.2H8.8c.66 0 3.25-.07 3.76.11.39.43.5.97.06 1.43-.25.26-.76.2-1.08.22H5.6c-.65 0-1.71-.03-2.33.01.04.15.08.36.15.49"
        opacity=".5"
      />
      <path d="M5.03 12.41c.2.13 1.07.42 1.35.52 1.68.6 3.7 1.86 5.5 1.92 1.68.05 3.51-1.04 5.04-1.63l2.12-.82c0 1.1.15 4.21-.24 5.05q-.25.48-.64.86c-1.32 1.3-4.37 1.87-6.2 1.84-2.14-.05-4.68-.5-6.28-2.02-.8-.76-.67-2-.68-3q0-1.37.03-2.72" />
    </g>
  </SvgIcon>
);

export default TrainingIcon;
